import QRCodeGenerator from "../qrcode/QRCodeGenerator";
import { Box, Button, Divider, Grid,  Typography, Card,TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,Paper } from "@mui/material";
import qrcode from 'qrcode';
import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
const LabelParentRollDetails = ({ qrCodeValue, ProductDetail, company_id }) => {


    // const detailsArray = Array.isArray(ProductDetail) ? ProductDetail : [ProductDetail];

    // call print QR Code
    const userPermissions = useUserPermissions();

    const handleButtonClick = async (mo_number, lot_no) => {

        let isvalid = true;
        // Filter for the parent roll matching mo_number and lot_no
        const parentRoll = ProductDetail.find(
            (detail) => detail.mo_number === mo_number && detail.lot_no === lot_no
        );

        if (!parentRoll) {
            isvalid = false;
            //setviewSheeterchildRollSummaryDetail(true);          
            //callError('info', 'Please select parent roll code to print.', 'info');
            console.error('Parent roll with specified mo_number and lot_no not found.');
            return;
        }


        if (isvalid == true) {


            const printWindow = window.open('', '_blank');
            try {
                // Generate HTML content for each QR code parentRollNumber
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(parentRoll.pr_number + parentRoll.parent_roll_seq);
                // Check if QR code generation was successful
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', parentRoll.pr_number);
                }
                // Write HTML content for the QR code to the print window
                printWindow.document.write(`

                <html>
                    <head>
                        <title>Printed Report</title>
                        <style>
                        body {
                            margin: 0;
                            padding: 0;
                            font-family: Arial, sans-serif;
                        }
                        .container {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 10px;
                            border: 1px solid #ccc;
                            box-sizing: border-box;
                        }
                        .qr-code {
                            width: 150px; /* Adjust as needed */
                        }
                        .bundle-details {
                            flex: 1;
                            margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                        }
                        .bundle-details h5 {
                            margin: 0;
                            font-size: 18px;
                        }
                        .bundle-details h6 {
                            margin: 5px 0;
                            font-size: 16px;
                        }
                        .details-table {
                                    display: grid;
                                    grid-template-columns: 120px auto;
                                    gap: 10px 20px;
                                    margin-top: 10px;
                                }
                                .details-table div {
                                    font-size: 16px;
                                }
                                .details-table .label {
                                    font-weight: bold;
                                }
                                .bundle-details hr {
                                    margin: 10px 0;
                                    border: 1px solid #ccc;
                                }
                    </style>
                    </head>
                    <body>
                    <div class="container">
                    <div>
                        <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                        <h3>${parentRoll.pr_number + parentRoll.parent_roll_seq || 'XXXXXX0123'}</h3>
                    </div>
                    <div class="bundle-details">
                        
                            <h5>Parent Roll Details</h5>
                            <hr/>
                         <div class="details-table">                       
                         <div class="label">DATE / SHIFT </div><div>:  ${parentRoll.shift_date} / ${parentRoll.shift_code}</div>  
                         <div class="label">M.O NO </div><div>: ${parentRoll.mo_number}</div> 
                         <div class="label">M.A NO </div><div>:  ${parentRoll.lot_no}</div> 
                         <div class="label">QUALITY </div><div>:  ${parentRoll.item_code}</div>                        
                         <div class="label">GSM </div><div>:  ${parentRoll.gsm}</div>
                         <div class="label">ID/OD </div><div>: ${parentRoll.core_id}" / ${parentRoll.reel_od} CM</div>
                         <div class="label">WINDER </div><div>:  ${parentRoll.winder_cut}</div>
                         <div class="label">COMBINATION </div><div>:  ${parentRoll.combination}</div>
                         <div class="label">WEIGHT (MT) </div><div>:  ${parentRoll.planned_qty}</div>
                         <div class="label">REEL LENGTH </div><div>:  ${parentRoll.reel_length}</div>
                         <div class="label">DECKLE</div><div>:  ${parentRoll.achieved_deckle || 0}(Mt)</div>
                         <div class="label">REMARKS </div><div>: ${parentRoll.remarks || ''} </div>
                         </div>                   
                        
                       
                    </div>
                      
                </div>
                    </body>
                </html>
            
            
                
            `);

                // <h6>Size : ${size}</h6>
                // Close the print window and print the report
                // printWindow.document.close();
                // printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }


        }



    };
    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };






    return (
        <>


            {/* Loop over ProductDetail array */}
            {ProductDetail.map((detail, index) => (
                <>
                    {company_id === 1 ? (
                        <Card sx={{ backgroundColor: "transparent", m: 2 }} >
                            <Box sx={{ p: 2 }} marginTop={5}>

                                <div key={index}>
                                    <Box mb={0}>
                                        <Typography variant="h4" textAlign="center">Parent Roll Details</Typography>
                                    </Box>
                                    <Divider sx={{ marginBottom: "5px" }} />
                                    <Grid container spacing={0} justifyContent="space-between" alignItems="center">
                                        <Grid item xs={12} lg={8}>
                                            <Grid container spacing={0}>
                                                {/* Date and Shift */}
                                                <Grid item xs={12} sm={6} md={3} lg={4} >
                                                    <Typography variant="h7">{`DATE / SHIFT `}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={9} lg={5}>
                                                    <Typography variant="h7">: {`${detail.shift_date} / ${detail.shift_code}`}</Typography>
                                                </Grid>

                                                {/* M.O No */}
                                                <Grid item xs={12} sm={6} md={3} lg={4}>
                                                    <Typography variant="h7">M.O NO </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={9} lg={5}>
                                                    <Typography variant="h7">: {detail.mo_number}</Typography>
                                                </Grid>

                                                {/* M.A No */}
                                                <Grid item xs={12} sm={6} md={3} lg={4}>
                                                    <Typography variant="h7">M.A NO </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={9} lg={5}>
                                                    <Typography variant="h7">: {detail.lot_no}</Typography>
                                                </Grid>

                                                {/* Quantity */}
                                                <Grid item xs={12} sm={6} md={3} lg={4}>
                                                    <Typography variant="h7">QUALITY </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={9} lg={5}>
                                                    <Typography variant="h7">: {detail.item_code}</Typography>
                                                </Grid>

                                                {/* GSM */}
                                                <Grid item xs={12} sm={6} md={3} lg={4}>
                                                    <Typography variant="h7">GSM </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={9} lg={5}>
                                                    <Typography variant="h7">: {detail.gsm}</Typography>
                                                </Grid>

                                                {/* No. Set */}
                                                <Grid item xs={12} sm={6} md={3} lg={4}>
                                                    <Typography variant="h7">NO. SET </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={9} lg={5}>
                                                    <Typography variant="h7">: {detail.number_of_sets}</Typography>
                                                </Grid>

                                                {/* ID / OD */}
                                                <Grid item xs={12} sm={6} md={3} lg={4}>
                                                    <Typography variant="h7">{`ID / OD `}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={9} lg={5}>
                                                    <Typography variant="h7">: {`${detail.core_id}" / ${detail.reel_od} CM`}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* QR Code */}
                                        <Grid item xs={12} lg={4} md={4} textAlign="center">
                                            <Typography variant="h7">{detail.pr_number + detail.parent_roll_seq}</Typography>
                                            <QRCodeGenerator value={detail.pr_number} />
                                        </Grid>
                                    </Grid>

                                    <Box sx={{ marginTop: "10px", marginBottom: "10px" }}>
                                        <Grid container spacing={0}>
                                            {/* Winder */}
                                            <Grid item xs={12} sm={4} lg={2.7}>
                                                <Typography variant="h7">WINDER </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} lg={9.3}>
                                                <Typography variant="h7">: {detail.winder_cut}</Typography>
                                            </Grid>

                                            {/* Combination */}
                                            <Grid item xs={12} sm={4} lg={2.7}>
                                                <Typography variant="h7">COMBINATION </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} lg={9.3}>
                                                <Typography variant="h7">: {detail.combination}</Typography>
                                            </Grid>

                                            {/* Weight */}
                                            <Grid item xs={12} sm={4} lg={2.7}>
                                                <Typography variant="h7">WEIGHT (MT) </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} lg={9.3}>
                                                <Typography variant="h7">: {detail.planned_qty}</Typography>
                                            </Grid>

                                            {/* Reel Length */}
                                            <Grid item xs={12} sm={4} lg={2.7}>
                                                <Typography variant="h7">REEL LENGTH </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} lg={9.3}>
                                                <Typography variant="h7">: {detail.reel_length}</Typography>
                                            </Grid>

                                            {/* Deckle */}
                                            <Grid item xs={12} sm={4} lg={2.7}>
                                                <Typography variant="h7">DECKLE </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} lg={9.3}>
                                                <Typography variant="h7">: {detail.achieved_deckle}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Divider sx={{ marginTop: "5px" }} />
                                    {/* Remarks */}
                                    <Grid item xs={12} lg={9}>
                                        <Typography variant="h7" sx={{ marginTop: "20px", marginBottom: "5px" }}>REMARKS:{detail.remarks||''}</Typography>
                                    </Grid>

                                    {hasPermission(userPermissions, "Paper Machine Production", "Print") && (
                                        <Grid item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                            <Button size="small" startIcon={<QrCodeRoundedIcon />} sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.mo_number, detail.lot_no)}>Print</Button>
                                        </Grid>
                                    )}




                                </div>
                            </Box>
                        </Card>
                    ) : company_id === 2 ? (<>
                        <Card sx={{ backgroundColor: "transparent", m: 2 }} >
                            <Box sx={{ p: 2 }} marginTop={5}>

                                <div key={index}>
                                    <Box mb={0}>
                                        <Typography variant="h4" textAlign="center">Parent Roll Details</Typography>
                                    </Box>
                                    <Divider sx={{ marginBottom: "5px" }} />
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableBody>
                                                {[
                                                    { label: "DATE / SHIFT", value: `${detail.shift_date} / ${detail.shift_code}` },
                                                    { label: "M.O NO", value: detail.mo_number },
                                                    { label: "M.A NO", value: detail.lot_no },
                                                    { label: "QUALITY", value: detail.item_code },
                                                    { label: "GSM", value: detail.gsm },
                                                    { label: "NO. SET", value: detail.number_of_sets },
                                                    { label: "ID / OD", value: `${detail.core_id}" / ${detail.reel_od} CM` },
                                                    { label: "WINDER", value: detail.winder_cut },
                                                    { label: "COMBINATION", value: detail.combination },
                                                    { label: "WEIGHT (MT)", value: detail.planned_qty },
                                                    { label: "REEL LENGTH", value: detail.reel_length },
                                                    { label: "DECKLE", value: detail.achieved_deckle },
                                                ].map((item, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell align="right" sx={{ fontWeight: 'bold', width: '40%' }}>
                                                            <Typography variant="subtitle2">{item.label}:</Typography>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <Typography variant="body1">{item.value}</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {hasPermission(userPermissions, "Paper Machine Production", "Print") && (
                                        <Grid item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                            <Button size="small" startIcon={<QrCodeRoundedIcon />} sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.mo_number, detail.lot_no)}>Print</Button>
                                        </Grid>
                                    )}




                                </div>
                            </Box>
                        </Card>

                    </>) : null}
                </>
            ))}


        </>
    );


}
export default LabelParentRollDetails;